// Sound notification utility
const SOUNDS = {
  newWalkin: null,
  chatMessage: null,
  tableReady: null,
};

let audioCtx = null;

function getAudioContext() {
  if (!audioCtx) {
    audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  }
  return audioCtx;
}

function playTone(frequency, duration = 150, type = "sine", volume = 0.3) {
  try {
    const ctx = getAudioContext();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = type;
    osc.frequency.setValueAtTime(frequency, ctx.currentTime);
    gain.gain.setValueAtTime(volume, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + duration / 1000);
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start();
    osc.stop(ctx.currentTime + duration / 1000);
  } catch {
    // Silent fail if audio not supported
  }
}

export function playNewWalkinSound() {
  playTone(880, 120, "sine", 0.2);
  setTimeout(() => playTone(1100, 150, "sine", 0.2), 140);
}

export function playChatSound() {
  playTone(660, 100, "triangle", 0.15);
}

export function playTableReadySound() {
  playTone(523, 100, "sine", 0.2);
  setTimeout(() => playTone(659, 100, "sine", 0.2), 120);
  setTimeout(() => playTone(784, 150, "sine", 0.2), 240);
}

export function playAlertSound() {
  playTone(440, 200, "square", 0.1);
}
